// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.panel-container[data-v-03c310e4] {\n  margin: 0 auto;\n  width: 800px;\n  padding: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
